<template>
<div>
  <div v-if="loading">
    <Loading/>
  </div>
  <div v-if="!loading">
  <v-row justify="center">
    <v-col md="6">
      <v-card v-if="user.card != ''" class="info--text ml-4 grey darken-3" elevation="16">
        <v-card-title>Card details</v-card-title>
        <v-card-text>
          <v-row no-gutters class="primary--text">
            <v-col md="2" class="text-center">
              <span style="color: #757575">holder</span> <br/>
              <span style="font-size: 16px;">{{ user.holder }}</span>
            </v-col>
            <v-col class="text-center">
              <span style="color: #757575">cardNo</span> <br/>
              <span style="font-size: 16px;">{{ user.card }}</span>
            </v-col>
            <v-col md="2" class="text-center">
              <span style="color: #757575">exp</span> <br/>
              <span style="font-size: 16px;">{{ user.expiry }}</span> 
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <br v-if="user.card != ''"/>
      <v-container>
        <v-row>
          <v-col>
            <h4 > {{ user.card != '' ? 'Update card ?' : 'Add card ?' }} </h4>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              filled
              dense
              v-model="fname"
              label="Card holder's first name"
              >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              dense
              filled
              v-model="lname"
              label="Card holder's last name"
              >
            </v-text-field>
          </v-col>
        </v-row>
        <validation-observer ref="observer-4">
        <v-row>
          <v-col>
            <validation-provider
              rules="card"
              v-slot="{ errors }"
            >
            <v-text-field
              dense
              filled
              v-model="card"
              label="Card number"
              >
            </v-text-field>
            <span class="error--text">{{ errors[0] }}</span>
            </validation-provider>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <validation-provider
              rules="expiry"
              v-slot="{ errors }"
            >
            <v-text-field
              dense
              filled
              v-model="expiry"
              label="Expiry (mm/yy)"
              >
            </v-text-field>
            <span class="error--text">{{ errors[0] }}</span>
            </validation-provider>
          </v-col>
          <v-col>
            <validation-provider
              rules="length"
              v-slot="{ errors }"
            >
            <v-text-field
              dense
              filled
              v-model="cvv"
              label="Cvv"
              >
            </v-text-field>
            <span class="error--text">{{ errors[0] }}</span>
            </validation-provider>
          </v-col>
        </v-row>
        </validation-observer>
        <v-row>
          <v-col align="end">
            <v-btn
            block
            rounded
            height="50" 
            @click="saveUserCardInfo()" 
            class="primary"
            > {{text}} </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-col>
  </v-row>
  </div>
</div>
</template>
<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { getAuth } from "firebase/auth"; 
import Loading from "@/components/Loading";
const auth = getAuth();
const expiryRegex = /^[0-9]{2}\/[0-9]{2}$/
extend('card', {
  params: [],
  validate(value) {
    value = value.replace(/[^0-9]/g, "")
    const condTransform = (predicate, value, fn) => {
      if (predicate) {
        return fn(value);
      } else {
        return value;
      }
    };
    const doubleEveryOther = (current, idx) =>
      condTransform(idx % 2 === 0, current, x => x * 2)
    const reduceMultiDigitVals = current =>
      condTransform(current > 9, current, x => x - 9)
    let digits = value.split("").map(Number)
    let luhn_digit = digits[digits.length - 1]
    let total = digits
      .slice(0, -1)
      .reverse()
      .map(doubleEveryOther)
      .map(reduceMultiDigitVals)
      .reduce((curr, acc) => curr + acc, luhn_digit)
    return total % 10 === 0
  },
  message: "Invalid card number"
})
extend('expiry', {
  params: [],
  validate(value) {
    let valid = true;
    valid = expiryRegex.test(value)
    let parts = value.split("/")
    let expiry = new Date();
    expiry.setFullYear('20'+parts[1], parts[0])
    if (expiry > new Date()) {
      return valid
    } else {
      return false;
    }
  },
  message: "Invalid expiry"
})
extend('length', {
  params: [],
  validate(value) {
    if(value.length == 3)
    return true;
  },
  message: 'CVV must be three numbers'
})

export default {
  name: "UserCard",
  components: {
      ValidationProvider,
      ValidationObserver,
      Loading
    },
  data () {
    return {
      errors: [],
      fname: '',
      lname: '',
      card: '',
      expiry: '',
      cvv: '',
      user: {
        id: '',
        holder: '',
        card: '',
        expiry: ''
      },
      text: 'Add Card',
      loading: false,
    }
  },
  computed: {
    getUser(){
      return this.$store.getters['auth/getUser'];
    },
    redirectUrl(){
      return this.$store.getters['auth/getRedirectUrl'];
    },
    regId(){
      return this.$store.getters['auth/getRegId'];
    }
  },
  methods:{
    async saveUserCardInfo(){
        if(await this.$refs['observer-4'].validate() && this.fname != '' && this.lname != '' && this.cvv != ''){
        this.loading = true;
        let cardData = {
          fname: this.fname,
          lname: this.lname,
          cardno: this.card,
          month: this.expiry,
          cvv: this.cvv,
          id: this.getUser.id
        }
        await this.$store.dispatch('auth/registerUserCard', cardData)
        if(this.regId != ''){
          await this.$store.dispatch('auth/updateUserCard', {
            id: this.getUser.id,
            registrationId: this.regId,
            expiry: this.expiry
          });
        }
        if(this.redirectUrl != ''){
          location.href = this.redirectUrl;
        }
        await auth.signOut()
        .then(() =>{
          sessionStorage.clear();
          this.$store.commit('auth/logout');
        });
      }   
      else{
        alert('Please make sure to fill in details as required');
      }          
    }
  },
  async mounted() {
    if(this.getUser.card){
      this.text = 'Update Card';
      //show card customer's details
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        "registrationId": this.getUser.card.registrationId
      });
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
      };
      await fetch("https://us-central1-wrapp-waste.cloudfunctions.net/viewCard", requestOptions)
      .then(async (response) => {
        let data = await response.json();
        if(data.card){
          this.user.card = '**** **** **** '+data.card.last4Digits;
          this.user.expiry = data.card.expiryMonth + '/' + data.card.expiryYear,
          this.user.holder = data.card.holder
        }
      })
      .catch(error => {
        console.log('error', error);
      });
    }
  }
}
</script>

<style scoped>

</style>